/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntermediaryViewModel
 */
export interface IntermediaryViewModel {
    /**
     * 
     * @type {string}
     * @memberof IntermediaryViewModel
     */
    firstNames: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryViewModel
     */
    initials: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryViewModel
     */
    surname: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryViewModel
     */
    sanlamCode: string;
    /**
     * 
     * @type {boolean}
     * @memberof IntermediaryViewModel
     */
    isIFA: boolean;
}

/**
 * Check if a given object implements the IntermediaryViewModel interface.
 */
export function instanceOfIntermediaryViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "firstNames" in value;
    isInstance = isInstance && "initials" in value;
    isInstance = isInstance && "surname" in value;
    isInstance = isInstance && "sanlamCode" in value;
    isInstance = isInstance && "isIFA" in value;

    return isInstance;
}

export function IntermediaryViewModelFromJSON(json: any): IntermediaryViewModel {
    return IntermediaryViewModelFromJSONTyped(json, false);
}

export function IntermediaryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntermediaryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstNames': json['FirstNames'],
        'initials': json['Initials'],
        'surname': json['Surname'],
        'sanlamCode': json['SanlamCode'],
        'isIFA': json['IsIFA'],
    };
}

export function IntermediaryViewModelToJSON(value?: IntermediaryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'FirstNames': value.firstNames,
        'Initials': value.initials,
        'Surname': value.surname,
        'SanlamCode': value.sanlamCode,
        'IsIFA': value.isIFA,
    };
}

